'use strict';

/* globals define, RELATIVE_PATH, $, socket, window, document, navigator, utils */

define('lessonViewer', [
	RELATIVE_PATH + '/plugins/nodebb-plugin-lessons/static/vendor/vue.js',
	RELATIVE_PATH + '/plugins/nodebb-plugin-video/static/vendor/videojs/video.js',
	'answerTypes'
], function (Vue, videojs, answerTypes) {
	var LessonViewer = {};

	var player = {};
	var videoDisabledControls = undefined;

	LessonViewer.init = function (lesson, translations) {
		videoDisabledControls = lesson.videoDisabledControls;
		
		initVueApp({
			questions: lesson.questions,
			answerTypes: answerTypes,
			player: player,
			isStarted: false,
			isCompleted: false,
			askedQuestions: 0,
			validAnswers: 0,
			invalidAnswers: 0,
			lesson: lesson,
			translations: translations,
			uuid: utils.generateUUID()
		});

		waitForLessonVideo();
	};

	function initVueApp(initData) {
		new Vue({
			el: '#lesson-viewer',
			data: {
				initData: initData
			}
		});
	}

	function waitForLessonVideo() {
		$(window).on('videojs:player.ready', onLessonVideoLoaded);
	}

	function onLessonVideoLoaded() {
		player.id = $('#contentVideo > div').attr('id');

		if (player.id && videoDisabledControls) {
			videojs.getPlayer(player.id).controls(false);
		}

		$(window).off('videojs:player.ready', onLessonVideoLoaded);
	}

	return LessonViewer;
});
